export const markdown_faq_6_1 = `Per eliminare un ponte vai nella sezione Ponti. Nella card corrispondente, sotto la mappa, seleziona l'icona del cestino.`;
export const markdown_faq_6_2 = `ATTENZIONE! Puoi eliminare un ponte solo se si tratta di un ponte Nuovo, ovvero per il quale non sono presenti attività, né in corso, né archiviate e consegnate.

Puoi eliminare il Ponte solo dalla piattaforma WEB.`;
